<template>
  <div class="agent-permissions-apps">
    <header class="agent-permissions-apps__header">
      <span class="agent-permissions-apps__title">
        {{ $t('AGENT.APP_PERMISSIONS.GROUP_TITLE') }}
      </span>
      <ElInput
        v-model="search"
        size="small"
        :placeholder="$t('AGENT.APP_PERMISSIONS.SEARCH_PLACEHOLDER')"
        class="agent-permissions-apps__search"
        :suffix-icon="suffixSearchIcon"
      />
    </header>
    <Scrollable class="agent-permissions-apps__list-wrapper">
      <AgentPermissionsList
        :key-fn="({ id }) => id"
        :active="value"
        :active-fn="({ packageName }) => packageName"
        :items="filteredApps"
        class="agent-permissions-apps__list"
        @click="emitSelectedApp"
      >
        <template #default="{ item: { icon, name } }">
          <div class="agent-permissions-apps__list-item">
            <img
              v-if="icon"
              class="agent-permissions-apps__list-item-image"
              :src="icon"
              alt="App Icon"
            />
            <div
              v-else
              class="agent-permissions-apps__list-item-image-placeholder"
            />
            <span class="agent-permissions-apps__list-item-text">
              {{ name }}
            </span>
          </div>
        </template>
      </AgentPermissionsList>
    </Scrollable>
  </div>
</template>

<script>
import Scrollable from '@@/common/Scrollable';
import AgentPermissionsList from './AgentPermissionsList';

import { APPS, DIRECTION } from '@/store/types';
import { mapGetters } from 'vuex';

export default {
  name: 'AgentPermissionsAppList',
  components: {
    Scrollable,
    AgentPermissionsList,
  },
  props: {
    value: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      search: '',
    };
  },
  computed: {
    ...mapGetters({
      apps: APPS,
      direction: DIRECTION,
    }),
    filteredApps() {
      const search = this.search.trim().toLowerCase();
      if (!search) return this.apps;
      return this.apps.filter(({ name }) =>
        name.toLowerCase().includes(search),
      );
    },
    suffixSearchIcon() {
      if (this.direction === 'ltr') return 'el-icon-right';
      return 'el-icon-back';
    },
  },
  methods: {
    emitSelectedApp({ packageName }) {
      this.$emit('input', packageName);
    },
  },
};
</script>

<style lang="scss">
.agent-permissions-apps {
  $start-padding: $global-padding * 1.875;

  display: flex;
  flex-direction: column;

  &__header {
    padding-right: $start-padding;
    @include rtl() {
      padding-right: 0;
      padding-left: $start-padding;
    }
  }

  &__title {
    font-weight: bold;
    color: $lb-medium-black;
    font-size: rem-calc(15px);
  }

  &__search {
    margin-top: $global-margin;

    input {
      padding: 0 $global-padding * 0.625 !important;
    }

    .el-input__icon {
      font-size: rem-calc(18px);
    }
  }

  &__list-wrapper {
    flex: 1 1 0;
    margin: $global-margin / 2 0 0;
  }

  &__list {
    padding-right: $start-padding - rem-calc(3px);
    @include rtl() {
      padding-right: 0;
      padding-left: $start-padding - rem-calc(3px); // minus scrollbar width
    }
    margin: 0;

    &-item {
      $image-size: rem-calc(25px);

      width: 100%;

      display: flex;
      align-items: center;

      &-image,
      &-image-placeholder {
        $image-margin: $global-margin * 0.3;

        flex-basis: $image-size;
        height: $image-size;
        margin-right: $image-margin;
        @include rtl() {
          margin-right: 0;
          margin-left: $image-margin;
        }
      }

      &-image-placeholder {
        background-color: $lb-light-gray;
      }

      &-text {
        flex: 1 1 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
